export default __webpack_public_path__ + "29dd1deb725e25ac4c97ac20b883a14e.svg";